/**
 * @packageDocumentation
 * @module Auth
 * @category Core
 */

/**
 * Действия для работы со стором токенов авторизации пользователя.
 *
 * @group Store Actions
 */
export namespace AuthTokenStateActions {
  /**
   * Сохранение токенов при логине.
   */
  export class Login {
    static readonly type = '[AuthToken] Login';

    constructor(
      public readonly token: string,
      public readonly refreshToken: string,
    ) {}
  }

  /**
   * Обновление access токена с помощью ранее сохраненного refresh токена.
   *
   * @see {AuthTokenStateActions.Login}
   */
  export class Refresh {
    static readonly type = '[AuthToken] Refresh';
  }

  /**
   * Удаление текущих токенов и выход из системы.
   */
  export class Logout {
    static readonly type = '[AuthToken] Logout';
  }
}
